export default function getListBrands(data) {
  let brands = [];
  for (let item of data) {
    for (let brand of item.brands) {
      if (!brands.includes(brand.niceName)) {
        brands.push(brand.niceName);
      }
    }
  }
  return brands;
}
